export default __webpack_public_path__ + "static/media/DarkMode.c8368b2c.png";